import { z } from 'zod';
export const resetUserFactorRequestParamsSchema = z.object({
    accountId: z.string(),
});
export const resetUserFactorResponseSchema = z.void();
